// Interfaces for filter options from backend
export interface Region {
  id: string;
  name: string;
}

export interface Site {
  id: string;
  name: string;
}

export interface ExamType {
  code: string;
  name: string;
}

export interface SampleStatus {
  code: string;
  name: string;
}

export interface SampleType {
  code: string;
  name: string;
}

export interface Facility {
  code: string;
  name: string;
}

/**
 * ExamName structure from backend
 * Note: This is similar to ExamType but uses 'id' instead of 'code'
 * Used in order responses where exam details are returned
 */
export interface ExamName {
  id: string;
  name: string;
}

/**
 * ReprocessCause structure from backend
 * Used for filtering by reprocess causes
 */
export interface ReprocessCause {
  id: string;
  name: string;
}

export interface FilterOptionsResponse {
  regions: Region[];
  sites: Site[];
  examTypes: ExamType[];
  reprocessCauses?: ReprocessCause[];
  sampleStatuses?: SampleStatus[];
  sampleTypes?: SampleType[];
  facilities?: Facility[];
}

// Filter criteria for sending to backend
export interface FilterCriteria {
  priority?: string[];
  region?: Region[];
  sites?: Site[];
  examType?: ExamType[];
  sampleStatus?: SampleStatus[];
  sampleType?: SampleType[];
  facility?: Facility[];
  status?: string[];
  startDate?: Date;
  endDate?: Date;
  promiseStartDate?: Date;
  promiseEndDate?: Date;
  reprocessCauses?: ReprocessCause[];
}

export interface RegionalBackendDto {
  id: string;
  name: string;
}

export interface SiteBackendDto {
  id: string;
  name: string;
}

export interface ExamTypeBackendDto {
  id: string;
  name: string;
}

export class FilterOptionsMapper {
  private static mapGeneric<T extends { id: string; name: string }>(
    dtos: T[]
  ): { id: string; name: string }[] {
    return dtos.map((dto) => ({
      id: dto.id,
      name: dto.name
    }));
  }

  static mapRegionals(dtos: RegionalBackendDto[]): Region[] {
    return this.mapGeneric(dtos);
  }

  static mapSites(dtos: SiteBackendDto[]): Site[] {
    return this.mapGeneric(dtos);
  }

  static mapExamTypes(dtos: ExamTypeBackendDto[]): ExamType[] {
    return dtos.map((dto) => ({
      code: dto.id,
      name: dto.name
    }));
  }
}
